import React from "react";

interface AnnouncementPreviewProps {
  formData: {
    eventType: string;
    customerImpact: string;
    hotfix: string;
    businessSolution: string;
    affectedBrands: string[];
    modGenerations: string[];
    regions: string[];
    instances: string;
    downtimeImpact: string;
    developerActions: string;
    consumerActions: string;
    ticketLink: string;
    changeNotes: string;
    startDeployment: string;
    endDeployment: string;
    affectedServices: string[];
    businessAffected: string[];
    affectedApplications: string[];
    status: string;
    contactEmail: string; 
    slackName: string;
    slackLink: string;
    gmtOffset: string;
  };
}
const basePath = ''; // Define the base path


const AnnouncementPreview: React.FC<AnnouncementPreviewProps> = ({ formData }) => {
  const parseDate = (dateString: string): string => {
    const [day, month, yearTime] = dateString.split('.');
    const [year, time] = yearTime.split(' ');
    const [hours, minutes] = time.split(':');

    const formattedDateString = `${day}.${month}.${year} ${hours}:${minutes}`; // Convert to ISO 8601 format
    return formattedDateString;
    
  };  
  return (
    <div style={{ maxWidth: "900px",maxHeight: "900px", overflow: "auto", margin: "auto", fontFamily: "Montserrat, sans-serif", backgroundColor: "#1d0638", padding: "20px", color: "white", borderRadius: "8px", border: "1px solid #ddd" }}>
      
      {/* Header with Two Images */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img src={`${basePath}/header.png`} alt="Header 1" style={{ width: "100%", borderRadius: "5px", marginBottom: "10px" }} />
        <img src={`${basePath}/heading.png`} alt="Header 2" style={{ width: "100%", borderRadius: "5px" }} />
      </div>

      {/* Announcement Header */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <p style={{ fontSize: "20px", color: "#1eef97", textTransform: "uppercase" }}>{formData.affectedServices.join(", ")}</p>
        <p style={{ fontSize: "20px", fontWeight: "bold", color: "#ff0000", textTransform: "uppercase" }}>{formData.eventType}</p>
        <p
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            textTransform: "uppercase",
            color:
              formData.status === "Update"
                ? "#ffcc00"
                : formData.status === "Done"
                ? "#1eef97"
                : "#ffffff",
          }}
        >
          {formData.status}
        </p>
      </div>
        
      {/* Announcement Details */}
      <div style={{ padding: "15px", marginBottom: "20px" }}>
        <p style={{ fontSize: "18px" }}>Dear Consumers of Service and Device Platforms,</p>
        <p style={{ fontSize: "16px" }}>Please be informed that there is a change planned due to which, services/systems depending on {formData.affectedServices.join(", ")} may be impacted. Please review and assess the following notes regarding impact on your app/services!</p>
      </div>


      {/* VETO Section */}
      {formData.eventType !== "Emergency Change" && (
        <div style={{ textAlign: "center", padding: "20px", marginTop: "20px", borderTop: "1px solid white" }}>
          <p style={{ fontWeight: "bold", fontSize: "16px", color: "#1eef97", marginBottom: "5px" }}>!!! IMPORTANT !!!</p>
          <p style={{ fontWeight: "bold", fontSize: "14px", color: "#ff0000", marginBottom: "10px" }}>
            You can veto within one week against the deployment here:
          </p>
          <p style={{ color: "#ffffff", fontSize: "14px", margin: "0" }}>
            <a href={`mailto:care-ds@cariad.technology?subject=VETO%20-%20Release%20-%20${formData.ticketLink}&cc=cariad-estonia-subscr-aaaakpm4goazcdf2j2umtho5ci@cariad.org.slack.com&body=--VETO_MESSAGE--%0APlease%20fill%20out%20the%20form%20below.%20The%20contact%20will%20be%20used%20to%20align%20on%20the%20release.%0A%0AChangeID%20%2F%20SC3%20Number%3A%20${formData.ticketLink}%0A%0AReasoning%3A%20%0A%0APreferred%20Response%20Contact%3A%20%0A%0A`}
               style={{ color: "#1eef97", fontWeight: "bold", textDecoration: "underline" }}
               target="_blank" rel="noreferrer">
              SUBMIT VETO
            </a>
          </p>
        </div>
      )}

      {/* Main Content */}
      <div style={{ color: "#ffffff", padding: "15px", borderRadius: "5px" }}>
        {[
          { label: "Changed Business Solution", value: formData.businessSolution },
          { label: "Changed Service(s)",      
            value: (
            <div style={{ paddingTop: '8px'}}>
              {formData.affectedServices.map((item, idx) => (
                <div key={idx} style={{ paddingLeft: '10px' }}>• {item}</div>
              ))}
            </div>
          )   
      },
          {
            label: "Affected Business Solution(s)",
            value: (
              <div style={{ paddingTop: '8px'}}>
                {formData.businessAffected.map((item, idx) => (
                  <div key={idx} style={{ paddingLeft: '10px' }}>• {item}</div>
                ))}
              </div>
            )
          },          
          {
            label: "Affected Application(s)/Service(s)",
            value: (
              <div style={{ paddingTop: '8px'}}>
                {formData.affectedApplications.map((item, idx) => (
                  <div key={idx} style={{ paddingLeft: '10px' }}>• {item}</div>
                ))}
              </div>
            )
          },
          { label: "Affected Instances(s)", value: formData.instances || "" },
          {
            label: "Changed ID / SC3 Number",
            value: formData.ticketLink.toLowerCase().startsWith("cr")
              ? `<a href="https://sc3.vwgroup.com/sc3/index.do?ctx=docEngine&file=cm3r&query=header%2Cnumber%3D%22${formData.ticketLink}%22&action=&title=Change%20${formData.ticketLink}" style="color: #ffffff;"><span style="text-decoration: underline;">${formData.ticketLink}</span></a>`
              : formData.ticketLink,
          },
          { label: "Change notes", value: (
            <div style={{ paddingTop: "8px", wordWrap: "break-word" }}
              dangerouslySetInnerHTML={{ 
                __html: formData.changeNotes 
                  ? formData.changeNotes.replace(/\n/g, '<br />') 
                  : "No notes provided" 
              }}
            />
          )},
          { label: "Downtime & Impact on Users", value: (
            <div style={{ paddingTop: "8px", wordWrap: "break-word" }}
              dangerouslySetInnerHTML={{ 
                __html: formData.downtimeImpact 
                  ? formData.downtimeImpact.replace(/\n/g, '<br />') 
                  : "No notes provided" 
              }}
            />
          )},
          { label: "Actions Needed from Developers", value: (
            <div style={{ paddingTop: "8px", wordWrap: "break-word" }}
              dangerouslySetInnerHTML={{ 
                __html: formData.developerActions 
                  ? formData.developerActions.replace(/\n/g, '<br />') 
                  : "No notes provided" 
              }}
            />
          )},
          { label: "Actions Needed from Consumers", value: (
            <div style={{ paddingTop: "8px", wordWrap: "break-word" }}
              dangerouslySetInnerHTML={{ 
                __html: formData.consumerActions 
                  ? formData.consumerActions.replace(/\n/g, '<br />') 
                  : "No notes provided" 
              }}
            />
          )},
          { label: `Start of Deployment (Berlin Time ${formData.gmtOffset})`, value: parseDate(formData.startDeployment)},
          { label: `End of Deployment (Berlin Time ${formData.gmtOffset})`, value: parseDate(formData.endDeployment)},
          {
            label: "If you have any questions, then please",
            value: (
              <div style={{ paddingTop: "8px" }}>
                {formData.contactEmail && (
                  <div style={{ paddingLeft: "10px"}}>
                    • Contact Support email:{" "}
                    <a
                      href={`mailto:${formData.contactEmail}`}
                      style={{ color: "#ffffff", textDecoration: "underline" }}
                    >
                      {formData.contactEmail}
                    </a>
                  </div>
                )}
                {formData.slackName && formData.slackLink && (
                  <div style={{ paddingLeft: "10px" }}>
                    • Ask in our Slack channel:{" "}
                    <a
                      href={formData.slackLink}
                      style={{ color: "#ffffff", textDecoration: "underline" }}
                    >
                      {formData.slackName}
                    </a>
                  </div>
                )}
              </div>
            )            
          },                                
        ].filter(({ value }) =>
          value &&
          (Array.isArray(value)
            ? value.length > 0
            : typeof value === "string"
              ? value.trim() !== ""
              : true)
        )
        .map(({ label, value }) => (
          <div 
            key={label} 
            style={{ 
              marginBottom: "12px", 
              padding: "10px",
              borderBottom: "1px solid #ddd",
              wordWrap: "break-word", 
              overflowWrap: "break-word", 
              whiteSpace: "normal"
            }}
          >
            <strong>{label}: </strong>
            {Array.isArray(value) ? (
              <ul style={{ margin: "5px 0", paddingLeft: "10px" }}>
                {value.map((item, index) => (
                  <li 
                    key={index} 
                    style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}
                    dangerouslySetInnerHTML={{ __html: item as string }} // assumes items in array are always strings
                  />
                ))}
              </ul>
            ) : typeof value === "string" ? (
              <span
                style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }} 
                dangerouslySetInnerHTML={{ __html: value }}
              />
            ) : (
              <span>{value}</span> // safely render JSX (like the <div> blocks for businessAffected and affectedApplications)
            )}
          </div>
        ))}

        {/* Affected Brands, MOD Generations, and Regions Table */}
        <div 
          style={{ 
            marginBottom: "12px", 
            padding: "10px",
            borderBottom: "1px solid #ddd",
            wordWrap: "break-word", 
            overflowWrap: "break-word", 
            whiteSpace: "normal"
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", paddingBottom: "8px", color: "#ffffff", fontWeight: "bold" }}>Affected Brands</th>
                <th style={{ textAlign: "left", paddingBottom: "8px", color: "#ffffff", fontWeight: "bold" }}>MOD Generations</th>
                <th style={{ textAlign: "left", paddingBottom: "8px", color: "#ffffff", fontWeight: "bold" }}>Regions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", color: "#ffffff" }}>
                  {formData.affectedBrands.length > 0 
                    ? formData.affectedBrands.map((brand, index) => <div key={index}>{brand}</div>) 
                    : "N/A"}
                </td>
                <td style={{ verticalAlign: "top", color: "#ffffff" }}>
                  {formData.modGenerations.length > 0 
                    ? formData.modGenerations.map((mod, index) => <div key={index}>{mod}</div>) 
                    : "N/A"}
                </td>
                <td style={{ verticalAlign: "top", color: "#ffffff" }}>
                  {formData.regions.length > 0 
                    ? formData.regions.map((region, index) => <div key={index}>{region}</div>) 
                    : "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>


      {/* Additional Contact Section */}
      <div style={{ textAlign: "center", paddingLeft: "15px" }}>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {[
            { label: "Contact via email: ", linkText:"care-ds@cariad.technology", link: "mailto:care-ds@cariad.technology" },
            { 
              label: "Click here to change your subscription to Announcements: ", 
              linkText: "Subscription Self-Service", 
              link: `https://announcement-tool.care.cariad.digital/subscription`
            },
          ].map(({ label, linkText, link }, index) => (
            <li key={index} style={{ display: "flex", marginBottom: "10px" }}>
              <span style={{ color: "#ffffff", fontSize: "16px" }}>{label} </span>
              <a 
                href={link} 
                style={{ color: "#ffffff", textDecoration: "underline", fontSize: "16px", marginLeft: "5px" }}
              >
                {linkText}
              </a>
            </li>
          ))}
        </ul>
        
        {/* Website link with special spacing */}
        <div style={{ marginTop: "100px", paddingTop: "25px", borderTop: "1px solid #444", textAlign: "center" }}>
          <p style={{ color: "#ffffff", fontSize: "16px", marginBottom: "10px" }}>
            CARIAD Estonia - Digital services Operations center
          </p>
          <a 
            href="https://cariad.technology/de/en/company/regions/estonia.html" 
            target="_blank"
            rel="noopener noreferrer" 
            style={{ color: "#ffffff", textDecoration: "underline", fontSize: "16px"}}
          >
            CARIAD Estonia
          </a>
        </div>
      </div>

      {/* Footer */}
      <div style={{ textAlign: "center", marginTop: "-20px" }}>
        <img src={`${basePath}/footer.png`} alt="Footer" style={{ width: "100%", borderRadius: "5px" }} />
      </div>
    </div>
  );
};

export default AnnouncementPreview;
